import { Box, IconButton, useMediaQuery } from '@mui/material';
import { IoMdReturnLeft, IoMdSave } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { theme } from "../../../../utils/Theme";
import LoadingButtonCustom from "../../../../components/LoadingButtonCustom/LoadingButtonCustom";
import { AppButton } from "../../../../components/UI";

export default function SaveBar({ handleSubmit, editMode = false, handleEdit, loading }) {
  const history = useHistory();
  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));

  const loadingButtonProps = {
    handleSubmit,
    handleUpdate: handleEdit,
    loading,
    editMode,
  };

  return (
    <Box className="candidate-savebar">
      {isSmMode ? (
        <>
          <IconButton
            aria-label="Retourner"
            size="medium"
            onClick={() => history.goBack()}
            sx={{ background: '#f1f5f9', color: '#475569', borderRadius: '10px', '&:hover': { background: '#e2e8f0' } }}
          >
            <IoMdReturnLeft fontSize="18px" />
          </IconButton>
          <IconButton
            aria-label="Sauvegarder"
            size="large"
            onClick={() => editMode ? handleEdit() : handleSubmit()}
            sx={{ background: 'linear-gradient(135deg,#03407b,#02357a)', color: '#fff', borderRadius: '10px', '&:hover': { background: '#02357a' } }}
          >
            <IoMdSave />
          </IconButton>
        </>
      ) : (
        <>
          <AppButton variant="secondary" onClick={() => history.goBack()} disabled={loading}>
            Annuler
          </AppButton>
          <LoadingButtonCustom {...loadingButtonProps} />
        </>
      )}
    </Box>
  );
}
